var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { CountryCode, Entity, formatNumber } from '@debbie/common/dist';
import { CaseVoucherSource, } from '@debbie/common/dist/economy/case-vouchers';
import { VoucherCategory, VoucherTypeIds, } from '@debbie/common/dist/economy/vouchers';
import * as caseVouchersAPI from '@debbie/cortex/dist/api/case-vouchers';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors';
import { Checkbox, Button, Input, DateInput, FileDropzone, File, Alert, SearchInput, } from '../..';
import { toPercent, toDecimal } from '../../../utils';
import MoneyInput from '../../MoneyInput';
import NewEntityProperties from '../../Properties/NewEntityProperties';
import { CaseVoucherCategories } from '@debbie/common/dist/economy/vouchers/setup';
let tid;
const PrincipalVoucherCreator = (props) => {
    var _a, _b;
    const lang = useSelector((s) => s.lang);
    const singleCase = useSelector((s) => selectCaseById(s, props.caseId));
    const tenant = useSelector(selectTenant);
    const [dropzone, setDropzone] = useState(null);
    const [uploadingFile, setUploadingFile] = useState(false);
    const [reference, setReference] = useState(undefined);
    const [referenceVoucher, setReferenceVoucher] = useState(null);
    const [text, setText] = useState(undefined);
    const [amount, setAmount] = useState(NaN);
    const [dateChanged, setDateChanged] = useState(null);
    const [date, setDate] = useState(new Date());
    const [dueDate, setDueDate] = useState(null);
    const [appendix, setAppendix] = useState(null);
    const [imposedByCreditor] = useState(true);
    const [manualDate, setManualDate] = useState(false);
    const interestVoucher = ![VoucherTypeIds.CREDITNOTE].includes(props.voucherTypeId);
    const [withInterest, setWithInterest] = useState(interestVoucher);
    const interestType = props.voucherTypeId === VoucherTypeIds.GAELDSBREV
        ? VoucherTypeIds.YEARLYINTEREST
        : (tenant === null || tenant === void 0 ? void 0 : tenant.countryCode) === CountryCode.GL
            ? VoucherTypeIds.GLPROCESSINTEREST
            : VoucherTypeIds.PROCESSINTEREST;
    const [duplicates, setDuplicates] = useState(null);
    const [loading, setLoading] = useState(false);
    const [interest, setInterest] = useState(NaN);
    const [interestStartDate, setInterestStartDate] = useState(moment().add(31, 'days').toDate());
    const [interestEndDate, setInterestEndDate] = useState(null);
    const [interestImposedByCreditor, setInterestImposedByCreditor] = useState(false);
    const [properties, setProperties] = useState(null);
    useEffect(() => {
        // If date is changed manually, don't update it by OCR scanning the PDF
        setDateChanged(dateChanged !== null);
    }, [date]);
    const searchVouchers = useMemo(() => {
        const sv = props.caseVouchers.concat([]);
        sv.sort((a, b) => {
            if (a.category === b.category) {
                return new Date(a.date).getTime() - new Date(b.date).getTime();
            }
            return (CaseVoucherCategories.indexOf(a.category) -
                CaseVoucherCategories.indexOf(b.category));
        });
        return sv;
    }, [props.caseVouchers]);
    const checkForDuplicates = () => __awaiter(void 0, void 0, void 0, function* () {
        if (singleCase && reference && props.voucherTypeId) {
            const matches = yield caseVouchersAPI.checkForDuplicates(singleCase.creditorId, [
                {
                    referenceId: reference,
                    voucherTypeId: props.voucherTypeId,
                },
            ]);
            setDuplicates(matches);
        }
    });
    useEffect(() => {
        clearTimeout(tid);
        setDuplicates(null);
        tid = setTimeout(() => checkForDuplicates(), 500);
    }, [reference]);
    const canSubmit = reference != null &&
        reference != '' &&
        date != null &&
        dueDate != null &&
        Number.isInteger(amount) &&
        (withInterest
            ? (interestType === VoucherTypeIds.YEARLYINTEREST
                ? !Number.isNaN(interest)
                : true) && interestStartDate != null
            : true);
    const createVoucher = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!canSubmit) {
            return;
        }
        setLoading(true);
        yield props.onCreate({
            voucherTypeId: props.voucherTypeId,
            amount: [VoucherTypeIds.CREDITNOTE].indexOf(props.voucherTypeId) !== -1
                ? amount
                : -amount,
            referenceId: reference,
            date: date.toISOString(),
            dueDate: dueDate != null ? dueDate.toISOString() : undefined,
            appendix: appendix,
            source: imposedByCreditor
                ? CaseVoucherSource.Creditor
                : CaseVoucherSource.Collector,
            text: text != null && text !== '' ? text : undefined,
            referenceCaseVouchers: withInterest
                ? [
                    {
                        voucherTypeId: interestType,
                        amount: 0,
                        date: interestStartDate.toISOString(),
                        interestStartDate: interestStartDate.toISOString(),
                        interestEndDate: interestEndDate != null ? interestEndDate.toISOString() : null,
                        interest: interestType === VoucherTypeIds.YEARLYINTEREST
                            ? interest
                            : undefined,
                        source: interestImposedByCreditor
                            ? CaseVoucherSource.Creditor
                            : CaseVoucherSource.Collector,
                    },
                ]
                : [],
            referenceCaseVoucherId: (referenceVoucher === null || referenceVoucher === void 0 ? void 0 : referenceVoucher.caseVoucherId) || undefined,
            properties: properties || undefined,
        });
        setLoading(false);
    });
    return (React.createElement(Wrapper, null,
        React.createElement(FileDropzone, { setLoading: setUploadingFile, onChange: (file) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                setAppendix({
                    contentType: file === null || file === void 0 ? void 0 : file.contentType,
                    fileId: file === null || file === void 0 ? void 0 : file.fileId,
                    fileName: file === null || file === void 0 ? void 0 : file.fileName,
                });
                const invoiceEntities = ((_b = (_a = file === null || file === void 0 ? void 0 : file.meta) === null || _a === void 0 ? void 0 : _a.parsedInvoice) === null || _b === void 0 ? void 0 : _b.entities) || [];
                // voucher.referenceId
                const invoiceReferenceId = (_c = invoiceEntities.find((entity) => entity.type === 'invoice_id')) === null || _c === void 0 ? void 0 : _c.mentionText;
                if (invoiceReferenceId && !reference) {
                    setReference(invoiceReferenceId);
                }
                // voucher.amount
                const invoiceAmount = (_e = (_d = invoiceEntities.find((entity) => entity.type === 'total_amount')) === null || _d === void 0 ? void 0 : _d.normalizedValue) === null || _e === void 0 ? void 0 : _e.text;
                if (invoiceAmount && !amount) {
                    setAmount(Math.round(parseFloat(invoiceAmount) * 100));
                }
                // voucher.date
                const invoiceDate = (_g = (_f = invoiceEntities.find((entity) => entity.type === 'invoice_date')) === null || _f === void 0 ? void 0 : _f.normalizedValue) === null || _g === void 0 ? void 0 : _g.text;
                if (invoiceDate && !dateChanged) {
                    const _date = moment(invoiceDate, 'YYYY-MM-DD');
                    setDate(_date.toDate());
                    setInterestStartDate(_date.add(31, 'days').toDate());
                }
                // voucher.dueDate
                const invoiceDueDate = (_j = (_h = invoiceEntities.find((entity) => entity.type === 'due_date')) === null || _h === void 0 ? void 0 : _h.normalizedValue) === null || _j === void 0 ? void 0 : _j.text;
                if (invoiceDueDate && !dueDate) {
                    setDueDate(moment(invoiceDueDate, 'YYYY-MM-DD').toDate());
                }
            }, dropzoneRef: (r) => {
                setDropzone(r);
            }, parseInvoice: true },
            duplicates && !!duplicates.length && (React.createElement(Alert, { message: React.createElement(React.Fragment, null,
                    lang.economyVoucherTypeLabels[props.voucherTypeId],
                    " ",
                    reference,
                    ' ',
                    lang.economy.voucherAlreadyExists,
                    ' ',
                    duplicates.map((match, index) => (React.createElement(React.Fragment, null,
                        // @ts-ignore
                        React.createElement(Link, { style: {
                                color: 'inherit',
                            }, to: `/cases/${match.caseSeqId}` }, match.caseSeqId),
                        duplicates.length - 1 !== index && ', ')))) })),
            React.createElement(Input, { containerStyle: { width: '100%' }, placeholder: lang.economy.referenceId, value: reference != null ? reference : '', onChange: (e) => {
                    setReference(e.target.value);
                }, onBlur: () => checkForDuplicates() }),
            props.voucherTypeId === VoucherTypeIds.CREDITNOTE && (React.createElement(SearchInput, { resultsStyle: { maxHeight: '160px' }, placeholder: lang.economy.referenceVoucherCreditnote, forceOpen: true, searchAll: (q) => {
                    return searchVouchers
                        .filter((v) => [
                        VoucherCategory.PRINCIPAL,
                        VoucherCategory.COURTCOST,
                        VoucherCategory.COST,
                    ].includes(v.category) &&
                        (`${v.label} (${formatNumber(v.amount)})`
                            .toLocaleLowerCase()
                            .includes(q.toLocaleLowerCase()) ||
                            !q))
                        .filter((v) => v.amount < 0)
                        .map((v) => ({
                        key: v.caseVoucherId,
                        heading: (React.createElement(SearchWrapper, null,
                            React.createElement("span", null,
                                lang.economyVoucherTypeLabels[v.voucherTypeId],
                                ' ',
                                v.referenceId),
                            React.createElement("span", null, formatNumber(Math.abs(v.amount))))),
                        subheading: lang.economyCategories[v.category],
                        returnData: v,
                    }));
                }, onSelect: (v) => {
                    setReferenceVoucher(v);
                }, onRemoveStatic: () => setReferenceVoucher(null), static: (referenceVoucher &&
                    `${lang.economyVoucherTypeLabels[referenceVoucher.voucherTypeId]} ${(_a = referenceVoucher.referenceId) !== null && _a !== void 0 ? _a : ''} (${formatNumber(Math.abs(referenceVoucher.amount))})`) ||
                    null })),
            React.createElement(Input, { containerStyle: { width: '100%' }, placeholder: lang.economy.text, value: text != null ? text : '', onChange: (e) => {
                    setText(e.target.value);
                } }),
            React.createElement(OneLine, null,
                React.createElement(DateWrapper, null,
                    React.createElement(DateInput, { placeholder: lang.economy.date, value: moment(date), allowNull: false, onChange: (d) => {
                            setDate(d.toDate());
                            if (!manualDate) {
                                setInterestStartDate(moment(d).add(31, 'days').toDate());
                            }
                        } })),
                React.createElement(DateWrapper, null,
                    React.createElement(DateInput, { placeholder: lang.economy.dueDate, value: dueDate != null ? moment(dueDate) : undefined, allowNull: false, onChange: (d) => {
                            setDueDate(d.toDate());
                        } }))),
            React.createElement(InputWrapper, null,
                React.createElement(MoneyInput, { value: amount, onChange: setAmount, placeholder: lang.economy.amount })),
            appendix != null ? (React.createElement(File, { style: { marginBottom: '20px' }, onRemove: () => setAppendix(null), removable: true, file: appendix })) : (React.createElement(React.Fragment, null,
                React.createElement(Button, { style: { marginBottom: '20px' }, onClick: () => {
                        if (dropzone != null) {
                            dropzone.open();
                        }
                    }, size: "small", theme: "secondary", loading: uploadingFile }, lang.economy.addAppendix))),
            interestVoucher && (React.createElement(Checkbox, { placeholder: lang.economy.voucherCreationIncludeInterest, checked: withInterest, onChange: (e) => setWithInterest(e.target.checked), setting: true })),
            withInterest && (React.createElement(React.Fragment, null,
                interestType === VoucherTypeIds.YEARLYINTEREST && (React.createElement(Input, { containerStyle: { width: '100%' }, placeholder: lang.economy.interestRate, type: "number", value: !Number.isNaN(interest) ? toPercent(interest) : '', onChange: (e) => {
                        setInterest(toDecimal(parseFloat(e.target.value)));
                    } })),
                React.createElement(OneLine, null,
                    React.createElement(DateWrapper, null,
                        React.createElement(DateInput, { placeholder: lang.economy.interestStartDate, value: moment(interestStartDate), allowNull: false, onChange: (d) => {
                                setManualDate(true);
                                setInterestStartDate(d.toDate());
                            } })),
                    React.createElement(DateWrapper, null,
                        React.createElement(DateInput, { placeholder: lang.economy.interestEndDate, value: interestEndDate != null
                                ? moment(interestEndDate)
                                : undefined, allowNull: false, onChange: (d) => {
                                setInterestEndDate(d.toDate());
                            } }))),
                props.voucherTypeId !== VoucherTypeIds.INVOICE &&
                    props.voucherTypeId !== VoucherTypeIds.GAELDSBREV && (React.createElement(Checkbox, { placeholder: lang.economy.imposedByCreditor, onChange: (e) => setInterestImposedByCreditor(e.target.checked), checked: interestImposedByCreditor })))),
            ((_b = singleCase === null || singleCase === void 0 ? void 0 : singleCase.caseGroup) === null || _b === void 0 ? void 0 : _b.id) && (React.createElement(NewEntityProperties, { propRef: Entity.CaseVoucher, scope: "case_groups", scopeId: singleCase.caseGroup.id, onChange: (p) => {
                    let exists = false;
                    setProperties(properties && properties.length > 0
                        ? properties
                            .map((prop) => {
                            if (prop.handle === p.handle) {
                                exists = true;
                                return p;
                            }
                            else {
                                return prop;
                            }
                        })
                            .concat(exists ? [] : [p])
                        : [p]);
                } })),
            React.createElement(Button, { disabled: !canSubmit, style: { width: '100%' }, loading: loading, onClick: createVoucher },
                lang.economy.voucherCreationCreate,
                ' ',
                lang.economyVoucherTypeLabels[props.voucherTypeId]))));
};
export default PrincipalVoucherCreator;
const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
`;
const OneLine = styled.div `
  display: flex;
  justify-content: space-between;
`;
const DateWrapper = styled.div `
  width: calc(50% - 10px);
`;
const InputWrapper = styled.div `
  width: 100%;
`;
const SearchWrapper = styled.div `
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
//# sourceMappingURL=PrincipalVoucherCreator.js.map